export const BusinessRoleLabels = {
    Platform_Admin: 'ClearVerify Admin',
    Platform_Manager: 'ClearVerify Manager',
    Employer_Admin: 'Employer Admin',
    Employer_Manager: 'Employer Manager',
    Verifier_Admin: 'Verifier Admin',
    Verifier_Manager: 'Verifier Manager',
    Employee: 'Employee',
    Peo_Super_Admin: 'PEO Super Admin',
    Peo_Admin: 'PEO Admin',
    Peo_Manager: 'PEO Manager',
    Peo_Payroll_Provider_User: 'PEO Payroll Provider',
};
/**
 * Clear Verify staff roles as the product names them. They are stored as `PlatformStaffRole` plus
 * `PlatformStaff.isAbleToManagePlatformStaff`: Super Admin is a `Platform_Admin` with that flag.
 */
export const ClearVerifyStaffRole = {
    Manager: 'Manager',
    Admin: 'Admin',
    Super_Admin: 'Super_Admin',
};
export const ClearVerifyStaffRoleLabels = {
    Manager: 'Manager',
    Admin: 'Admin',
    Super_Admin: 'Super Admin',
};
//# sourceMappingURL=roles.js.map